import PropTypes from 'prop-types';
import { useMemo } from 'react';
import CheckboxSelectFilter from '../../../../Filters/CheckboxSelectFilter';
import { TourFeatures } from '../../../../../constants';
import useTourFilter from '../../../../../hooks/useTourFilter';

const TourFeaturesFilter = ({ tripId, variant, filterSpacingClass }) => {
  const { searchObj, filters, applyFilter } = useTourFilter(tripId);

  const options = useMemo(
    () =>
      Object.values(TourFeatures)
        .map((feature) => ({ feature, count: filters?.[feature.countField] || 0 }))
        .filter(
          (entry) => entry.count > 0 || (searchObj.features || []).includes(entry.feature.value),
        )
        .map((entry) => ({
          value: entry.feature.value,
          label: `${entry.feature.label} (${entry.count})`,
          plainTextLabel: entry.feature.label,
        })),
    [filters, searchObj.features],
  );

  if (options.length === 0) {
    return <></>;
  }

  return (
    <CheckboxSelectFilter
      label="Includes"
      options={options}
      values={searchObj.features || []}
      onChange={(features) => applyFilter({ features })}
      variant={variant}
      filterSpacingClass={filterSpacingClass}
      filterMaxWidthClass="max-w-full"
      menuWidthClass="w-full md:w-max"
    />
  );
};

TourFeaturesFilter.propTypes = {
  tripId: PropTypes.string,
  variant: PropTypes.string,
  filterSpacingClass: PropTypes.string,
};

TourFeaturesFilter.defaultProps = {
  tripId: undefined,
  variant: 'outline',
  filterSpacingClass: undefined,
};

export default TourFeaturesFilter;
